import {
  OR_TOGGLE_CANCEL_HOLIDAY_MODAL,
  OR_REQUEST_HOLIDAY_CANCEL,
  OR_HOLIDAY_CANCEL_SUCCESS,
  OR_HOLIDAY_CANCEL_ERROR,
} from '../../../actions/management/orSettings';

export const initialState = {
  isCancelModalVisible: false,
  isCancellingHoliday: false,
  isCancellingHolidayError: false,
  holidayToCancelId: null,
};

export default function cancelHolidayReducer(state = initialState, action) {
  switch (action.type) {
    case OR_TOGGLE_CANCEL_HOLIDAY_MODAL:
      return {
        ...state,
        isCancelModalVisible: !state.isCancelModalVisible,
        holidayToCancelId: action.id || null,
        isCancellingHolidayError: false,
      };
    case OR_REQUEST_HOLIDAY_CANCEL:
      return { ...state, isCancellingHoliday: true };
    case OR_HOLIDAY_CANCEL_SUCCESS:
      return {
        ...state,
        isCancelModalVisible: false,
        isCancellingHoliday: false,
        isCancellingHolidayError: false,
        holidayToCancelId: null,
      };
    case OR_HOLIDAY_CANCEL_ERROR:
      return { ...state, isCancellingHoliday: false, isCancellingHolidayError: true };
    default:
      return state;
  }
}
